import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "./crud"
import { getByIdOffline } from "./Get_one"

export async function getAppointmentsOffline({
  page = 1,
  limit = 20,
  filters = {},
}) {
  let appointments = await readAllData(STORES.APPOINTMENTS)

  if (filters.fullName) {
    const tokens = filters.fullName.toLowerCase().trim().split(/\s+/)
    appointments = appointments.filter((a) => {
      const name = (a.fullName || "").toLowerCase()
      return tokens.every((token) => name.includes(token))
    })
  }

  if (filters.startDate) {
    const start = new Date(filters.startDate)
    start.setHours(0, 0, 0, 0)
    appointments = appointments.filter(
      (a) => a.date && new Date(a.date) >= start,
    )
  }

  if (filters.endDate) {
    const end = new Date(filters.endDate)
    end.setHours(23, 59, 59, 999)
    appointments = appointments.filter(
      (a) => a.date && new Date(a.date) <= end,
    )
  }

  const totalItems = appointments.length
  const startIdx = (page - 1) * limit
  const paginated = appointments.slice(startIdx, startIdx + limit)

  return { data: paginated, totalItems }
}

export async function createAppointmentOffline(body) {
  const tempId = crypto.randomUUID()

  let fullName = body.fullName || ""
  let age = null

  if (body.patientId) {
    try {
      const patient = await getByIdOffline(STORES.PATIENTS, body.patientId)
      if (patient) {
        fullName =
          patient.fullName ||
          `${patient.nom || ""} ${patient.prenom || ""}`.trim()
        age = patient.age ?? null
      }
    } catch (_) {
      // patient lookup is best-effort
    }
  }

  const enrichedAppointment = {
    ...body,
    id: tempId,
    fullName,
    age,
    createdAt: new Date().toISOString(),
    __offline: true,
  }

  await mergeUpsertOffline(STORES.APPOINTMENTS, enrichedAppointment, {
    markOffline: true,
  })

  return enrichedAppointment
}
